import PropTypes from 'prop-types';
import React from 'react';
import { uniqueId } from 'lodash';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from './dataAids';

const FULL_INPUT_WIDTH = '31.66%';
const HALF_INPUT_WIDTH = '14.58%';
const INPUT_MARGINS = '2.5%';

// widths for xs and sm media queries:
const FULL_WIDTH_INPUT_SMALL = '100%';
const HALF_INPUT_WIDTH_SMALL = '46.25%';
const INPUT_MARGINS_SMALL = '7.5%';

class LabeledInput extends React.Component {
  constructor(props) {
    super(props);
    this._uniqueId = uniqueId('mls-input');
  }

  render() {
    const { type, size, lastField, order } = this.props;
    const { Block, Label, Input } = UX2.Element;
    const blockWidth = size === 'half' ? HALF_INPUT_WIDTH : FULL_INPUT_WIDTH;
    const marginRight = lastField ? '0' : INPUT_MARGINS;
    const smallBlockWidth = size === 'half' ? HALF_INPUT_WIDTH_SMALL : FULL_WIDTH_INPUT_SMALL;
    const smallMarginRight = size === 'half' && order === 0 ? INPUT_MARGINS_SMALL : '0';
    const smallStyles = { width: smallBlockWidth, marginRight: smallMarginRight };
    const styles = {
      block: {
        'paddingBottom': 'medium',
        'width': blockWidth,
        'marginRight': marginRight,
        '@xs-only': smallStyles,
        '@sm-only': smallStyles
      },
      label: {
        display: 'block',
        marginBottom: 'xxsmall'
      },
      inputSelect: {
        fontSize: '93.5%',
        lineHeight: 'normal'
      },
      inputText: {
        fontSize: '93.5%'
      }
    };
    return (
      <Block style={ styles.block } data-aid={ dataAids.MLS_SEARCH_INPUT_BLOCK_RND }>
        <Label
          for={ this._uniqueId }
          children={ this.props.labelText }
          style={ styles.label }
          data-aid={ dataAids.MLS_SEARCH_INPUT_LABEL_RND }
        />
        { type === 'DROP_DOWN' && (
          <Input.Select
            id={ this._uniqueId }
            tag='div'
            style={ styles.inputSelect }
            children={ this.props.children }
            data-aid={ dataAids.MLS_SEARCH_INPUT_SELECT_RND }
            { ...this.props }
          />
        ) }
        { type === 'SINGLE_LINE' && (
          <Input
            id={ this._uniqueId }
            tag='input'
            type='text'
            style={ styles.inputText }
            data-aid={ dataAids.MLS_SEARCH_INPUT_TEXT_RND }
            { ...this.props }
          />
        ) }
      </Block>
    );
  }
}

LabeledInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
  children: PropTypes.array,
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  lastField: PropTypes.bool,
  order: PropTypes.number
};

LabeledInput.defaultProps = {
  labelText: '',
  labelColor: 'highContrast'
};

export default LabeledInput;
